/* eslint-disable @typescript-eslint/naming-convention */

import dynamic from 'next/dynamic';
import {Modal} from 'modules/modals/components/Modal';
import {MODALS} from 'modules/modals/constants';
import {ModalLazyLoader} from 'components/ModalLazyLoader';
import {FC, useContext} from 'react';
import {ProductPickUpModalProvider} from 'modules/products/providers/PickUpModal';
import ProductVideoModal from 'modules/product-card/components/ProductVideoModal';
import {LoyaltyRestrictionPopup} from 'modules/product-card/components/LoyaltyRestrictionPopup';
import {useLoyaltyRestrictionInformerGtag} from 'modules/product-card/analytics/gtag/hooks/useLoyaltyRestrictionInformerGtag';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {ProductPageContext} from 'modules/product-card/context';

// const ProductSpecialRatingModal = dynamic(() => import('modules/product-card/components/ProductSpecialRatingModal'), {
//     loading: () => <ModalLazyLoader />,
// });

const ProductPickUpModal = dynamic(() => import('modules/products/components/PickUpModal'), {
    loading: () => <ModalLazyLoader />,
    ssr: false,
});

const ReserveProductModal = dynamic(() => import('modules/product-card/components/ReserveProductModal'), {
    loading: () => <ModalLazyLoader />,
    ssr: false,
});

const CreateProductReviewModal = dynamic(() => import('modules/modals/components/CreateProductReviewModal'), {
    loading: () => <ModalLazyLoader />,
    ssr: false,
});

const ProductCommentModerationModal = dynamic(() => import('modules/modals/components/ProductCommentModerationModal'), {
    loading: () => <ModalLazyLoader />,
    ssr: false,
});

const NotifyAvailableProductModal = dynamic(
    () => import('modules/product-card/components/NotifyAvailableProductModal'),
    {
        loading: () => <ModalLazyLoader />,
        ssr: false,
    },
);

// const ProductVideoModal = dynamic(() => import('modules/product-card/components/ProductVideoModal'), {
//     loading: () => <ModalLazyLoader />,
// });

const ProductModalsBlock: FC = () => {
    const productData = useAppSelector(selectProductData);
    const {wineshopForReserveProduct} = useContext(ProductPageContext);
    const {handleLoyaltyRestrictionPopupClose} = useLoyaltyRestrictionInformerGtag({
        product: productData ? {id: productData.id, title: productData.title, price: productData.price} : null,
    });

    return (
        <>
            {/* <Modal name={MODALS.PRODUCT_RATING.name} willMount>*/}
            {/*    <ProductSpecialRatingModal />*/}
            {/* </Modal>*/}
            <Modal name={MODALS.PRODUCT_PICKUP.name} willMount={true}>
                <ProductPickUpModalProvider>
                    <ProductPickUpModal />
                </ProductPickUpModalProvider>
            </Modal>
            <Modal name={MODALS.PRODUCT_RESERVE.name} willMount={true} hasPortal={true}>
                <ReserveProductModal productData={productData} wineshop={wineshopForReserveProduct} />
            </Modal>
            <Modal name={MODALS.PRODUCT_NOTIFY_AVAILABLE.name} willMount={true}>
                <NotifyAvailableProductModal />
            </Modal>
            <Modal name={MODALS.CREATE_PRODUCT_REVIEW.name} willMount={true} hasPortal={true}>
                <CreateProductReviewModal />
            </Modal>
            <Modal name={MODALS.PRODUCT_COMMENT_MODERATION.name} willMount={true} hasPortal={true}>
                <ProductCommentModerationModal />
            </Modal>
            <Modal name={MODALS.PRODUCT_VIDEO_MODAL.name} hasPortal={true} willMount={true}>
                <ProductVideoModal />
            </Modal>
            <Modal
                name={MODALS.PRODUCT_LOYALTY_RESTRICTION_MODAL.name}
                hasPortal={true}
                willMount={true}
                onClose={handleLoyaltyRestrictionPopupClose}
            >
                <LoyaltyRestrictionPopup />
            </Modal>
        </>
    );
};

export default ProductModalsBlock;
